import type { VendorDeviceMeta } from '../../components/vendorDevice';

/** 卷挂载状态 */
export enum VolumeMountType {
  NotMount = 'NotMount',
  ReadOnly = 'ReadOnly',
  ReadWrite = 'ReadWrite',
  ReadWriteMany = 'ReadWriteMany',
  ReadWriteOnce = 'ReadWriteOnce',
  ReadOnlyMany = 'ReadOnlyMany',
}

export interface VolumeMountItem {
  containerName: string;
  mountType: VolumeMountType;
  mountPath?: string;
}

export enum VolumeMountTab {
  PERSISTENCE = 'Persistence',
  TEMPORARY = 'Temporary',
  HOST_PATH = 'HostPath',
}

export interface VolumeMountsProps {
  volumeMounts?: VolumeMountItem[];
  reclaimPolicy?: string;
}

export interface VolumeStorageItem extends VolumeMountsProps {
  type: VolumeMountTab;
  selected: string;
  volumeName: string;
  volumeHostPath: string;
  /** 已有 PVC 的 Gi 容量，仅用于卡片和配置预览展示。 */
  volumeCapacity?: number;
}

export interface VolumeClaimTemplateItem extends VolumeMountsProps {
  type: 'VolumeClaimTemplate';
  volumeName?: string;
  storageClass?: string;
  accessModes?: string[];
  volumeCapacity?: number;
  /** 计价厂商设备（SKU / 下单创建共享卷声明模板） */
  pricing?: VendorDeviceMeta;
  /** 镜像 containerDeployConfig 预置卷；换镜像时应清除 */
  _fromImage?: boolean;
}

export type VolumeItem = VolumeStorageItem | VolumeClaimTemplateItem;

export function isVolumeStorageItem(item: VolumeItem): item is VolumeStorageItem {
  return Object.values(VolumeMountTab).includes(item?.type as VolumeMountTab);
}

export function isVolumeClaimTemplateItem(item: VolumeItem): item is VolumeClaimTemplateItem {
  return item?.type === 'VolumeClaimTemplate';
}
